var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMakeQuizIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 38,
    viewBox: "0 0 31 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 7.6V3.8H28.625C29.6562 3.8 30.5 2.945 30.5 1.9C30.5 0.855 29.6562 0 28.625 0H4.25C2.1875 0 0.5 1.71 0.5 3.8V34.2C0.5 36.29 2.1875 38 4.25 38H28.625C29.6562 38 30.5 37.145 30.5 36.1C30.5 35.055 29.6562 34.2 28.625 34.2H22.9438C24.1221 33.3247 25.0807 32.1806 25.7419 30.8603C26.4032 29.54 26.7485 28.0806 26.75 26.6V20.9C26.75 18.81 25.0625 17.1 23 17.1H11.75C9.6875 17.1 8 18.81 8 20.9V26.6C8 29.716 9.51875 32.471 11.8062 34.2H4.25V3.8H8V7.6C8 8.645 8.84375 9.5 9.875 9.5H24.875C25.9062 9.5 26.75 8.645 26.75 7.6Z",
    fill: "#414141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeQuizIcon);
export default __webpack_public_path__ + "static/media/make-quiz-icon.226b100446b8e333c07c745b8f05f190.svg";
export { ForwardRef as ReactComponent };